<template>
  <div>
    <!-- 静默检测容器 -->
    <!-- <div v-if="error" class="error">{{ error }}</div> -->
    <el-dialog
      :visible.sync="showUAEWarning"
      :show-close="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="400px"
      center
    >
      <div class="uae-warning">
        <i class="el-icon-warning-outline warning-icon"></i>
        <p class="warning-text" style="margin-top: 20px;">{{ translateTitle("We are currently upgrading our services to fully comply with the regulations of the Virtual Assets Regulatory Authority (VARA) of the United Arab Emirates.") }}</p>
        <p class="warning-text">{{ translateTitle("Access from within the United Arab Emirates is temporarily suspended. We appreciate your patience and support.") }}</p>
      </div>
      <!-- 添加确认关闭按钮 -->
      <div class="dialog-footer">
        <el-button style="background-color: #FF8A00;border: none;" type="primary" @click="showUAEWarning=false">{{ translateTitle("Confirm Close") }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import commonMixin from "@/components/common/commonMixin.vue";
import {uaeIPRanges, uaeIPv6Ranges} from "@/assets/constant";

export default {
  data() {
    return {
      // 更全面的阿联酋IP段列表
      uaeIPRanges: uaeIPRanges,
      // 阿联酋IPv6地址段
      uaeIPv6Ranges: uaeIPv6Ranges,
      userIP: null,
      error: null,
      showUAEWarning: false,
      isAE: false
    };
  },
  mixins: [commonMixin],
  mounted() {
    // 先尝试WebRTC方式获取IP
    this.detectLocalIP()
      .then((ip) => {
        // console.error("ip",ip);
        this.processIP(ip);
      })
      .catch(err => {
        // console.error('WebRTC IP检测失败，尝试备用方案', err);
        this.getPublicIPFallback();
      });
  },
  methods: {
    processIP(ip) {
      this.userIP = ip;
      if (this.checkUAEIP()) {
        this.isAE = true;
        this.showUAEWarning = true;
      } else {
        this.getIsAE(ip)
      }
    },
    
    detectLocalIP() {
      return new Promise((resolve, reject) => {
        // 设置超时处理
        const timeout = setTimeout(() => {
          reject(new Error('WebRTC检测超时'));
        }, 5000);
        
        try {
          // 使用WebRTC获取本地IP信息
          const pc = new RTCPeerConnection({
            iceServers: [{ urls: 'stun:stun.l.google.com:19302' }]
          });

          pc.createDataChannel('');
          
          pc.onicecandidate = ice => {
            if (!ice.candidate || !ice.candidate.candidate) return;
            
            const ipv4Regex = /([0-9]{1,3}(\.[0-9]{1,3}){3})/;
            const ipv4Match = ice.candidate.candidate.match(ipv4Regex);
            
            // IPv6 正则表达式
            const ipv6Regex = /(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))/;
            const ipv6Match = ice.candidate.candidate.match(ipv6Regex);
            if (ipv4Match && ipv4Match[1]) {
              clearTimeout(timeout);
              pc.onicecandidate = null;
              pc.close();
              resolve(ipv4Match[1]);
            } else if (ipv6Match && ipv6Match[1]) {
              clearTimeout(timeout);
              pc.onicecandidate = null;
              pc.close();
              ipV6=ipv6Match[1]
              resolve(ipv6Match[1]);
            }
          };

          pc.createOffer()
            .then(offer => pc.setLocalDescription(offer))
            .catch(err => {
              clearTimeout(timeout);
              reject(new Error('WebRTC不支持或已被阻止: ' + err.message));
            });
        } catch (err) {
          clearTimeout(timeout);
          reject(new Error('WebRTC初始化失败: ' + err.message));
        }
      });
    },

    async getPublicIPFallback() {
      try {
        // 尝试多个备用API，提高可靠性
        const apis = [
          'https://api.my-ip.io/ip.json',
          // 'https://api.ipify.org?format=json'
          // 'https://ipapi.co/json/',
          // 'https://ipinfo.io/json'
        ];
        
        for (const api of apis) {
          try {
            const resp = await fetch(api);
            if (!resp.ok) continue;
            
            const data = await resp.json();
            const ip = data.ip || data.ipAddress;
            
            if (ip) {
              this.getIsAE(ip);
              return;
            }
          } catch (e) {
            // console.error(`API ${api} 请求失败`, e);
            // 继续尝试下一个API
          }
        }
        
        // throw new Error('所有API请求均失败');
      } catch (err) {
        this.error = '无法获取IP地址: ' + err.message;
      }
    },
    // 通过接口获取地区
    async getIsAE(ip) {
      try {
        // 尝试多个备用API，提高可靠性
        const apis = [
          `https://api.ip.sb/geoip/${ip}`
        ];
        
        for (const api of apis) {
          try {
            const resp = await fetch(api);
            if (!resp.ok) continue;
            
            const data = await resp.json();
            console.error("data", data)
            const isAE = data.country_code === "AE" || data.country === "United Arab Emirates" || data.country_code === "UAE";
            
            if (isAE) {
              this.isAE = true;
              // 弹窗弹窗
              this.showUAEWarning = true;
              return;
            }
          } catch (e) {
            // console.error(`API ${api} 请求失败`, e);
            // 继续尝试下一个API
          }
        }
        
        // throw new Error('所有API请求均失败');
      } catch (err) {
        this.error = '无法获取IP地址: ' + err.message;
      }
    },

    checkUAEIP() {
      if (!this.userIP) return false;
      
      // 检查是否为IPv4地址
      if (this.userIP.includes('.')) {
        return this.uaeIPRanges.some(cidr => this.isInCIDRRange(this.userIP, cidr));
      } 
      // 检查是否为IPv6地址
      else if (this.userIP.includes(':')) {
        return this.uaeIPv6Ranges.some(cidr => this.isInIPv6CIDRRange(this.userIP, cidr));
      }
      
      return false;
    },

    // ip:当前ip, cidr:阿联酋ip段
    isInCIDRRange(ip, cidr) {
      try {
        const [network, mask] = cidr.split('/');
        const ipInt = this.ipToInt(ip);
        const networkInt = this.ipToInt(network);
        const maskBits = parseInt(mask);
        const maskInt = ~(0xFFFFFFFF >>> maskBits);
        
        return (ipInt & maskInt) === (networkInt & maskInt);
      } catch (err) {
        // console.error('IP范围检查错误:', err, ip, cidr);
        return false;
      }
    },

    ipToInt(ip) {
      return ip.split('.').reduce((acc, octet) => (acc << 8) + parseInt(octet, 10), 0) >>> 0;
    },
    
    isInIPv6CIDRRange(ip, cidr) {
      try {
        const [network, prefixLength] = cidr.split('/');
        const prefix = parseInt(prefixLength);
        
        // 将IPv6地址转换为标准格式
        const normalizedIP = this.normalizeIPv6(ip);
        const normalizedNetwork = this.normalizeIPv6(network);
        
        // 计算需要比较的字节数
        const bytesToCompare = Math.ceil(prefix / 8);
        
        // 将地址转换为字节数组进行比较
        const ipBytes = this.ipv6ToBytes(normalizedIP);
        const networkBytes = this.ipv6ToBytes(normalizedNetwork);
        
        // 完全匹配的字节
        for (let i = 0; i < Math.floor(prefix / 8); i++) {
          if (ipBytes[i] !== networkBytes[i]) {
            return false;
          }
        }
        
        // 处理不完整的最后一个字节
        if (prefix % 8 !== 0) {
          const lastByteIndex = Math.floor(prefix / 8);
          const remainingBits = prefix % 8;
          const mask = 0xff << (8 - remainingBits);
          
          if ((ipBytes[lastByteIndex] & mask) !== (networkBytes[lastByteIndex] & mask)) {
            return false;
          }
        }
        
        return true;
      } catch (err) {
        // console.error('IPv6范围检查错误:', err, ip, cidr);
        return false;
      }
    },
    
    normalizeIPv6(ip) {
      // 处理IPv6地址的简写形式，转换为完整形式
      if (ip.includes('::')) {
        const parts = ip.split('::');
        const left = parts[0] ? parts[0].split(':') : [];
        const right = parts[1] ? parts[1].split(':') : [];
        const missing = 8 - left.length - right.length;
        
        const middle = Array(missing).fill('0000');
        const full = [...left, ...middle, ...right];
        
        return full.map(part => part.padStart(4, '0')).join(':');
      } else {
        return ip.split(':').map(part => part.padStart(4, '0')).join(':');
      }
    },
    
    ipv6ToBytes(ip) {
      // 将标准化的IPv6地址转换为字节数组
      return ip.split(':').map(hex => {
        const num = parseInt(hex, 16);
        return [(num >> 8) & 0xff, num & 0xff];
      }).flat();
    }
  },
  // 判断路由变化
  watch: {
    $route(to, from) {
      // console.log("路由变化", to, from);
      if (this.isAE) {
        this.showUAEWarning = true;
      }
    }
  }
};
</script>

<style>
.error {
  color: red;
  padding: 10px;
}

.uae-warning {
  text-align: center;
  padding: 20px;
}

.warning-icon {
  font-size: 48px;
  color: #E6A23C;
  margin-bottom: 15px;
}

.uae-warning h3 {
  font-size: 18px;
  margin-bottom: 15px;
  color: #303133;
}

.uae-warning p {
  margin-bottom: 10px;
  color: #606266;
  line-height: 1.5;
}

.warning-text {
  text-align-last: left;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px; 
}
</style>